"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/sliderSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SliderSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "First Month Trial – $9.99" | "Custom meal plans updated biweekly" | "Summer Wellness Offer – 25% Off" | "New Member Discount – 20% Off" | "Family Package Deal – Save $50 Monthly" | "Group coaching sessions" */
    h20Text?: ReactNode;
    /** Detected variants: "title" */
    className?: string;
    /** Detected variants: "icon" */
    span0ClassName?: string;
    /** Detected variants: "isax isax-percentage-circle5" */
    i0ClassName?: string;
    /** Detected variants: "services-slide" */
    divClassName?: string;
};
export type HomeSixteenSliderSectionGeneratedProps = {
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    sliderSectionServicesSlides: SliderSectionServicesSlidesItem[];
    sliderSectionServicesSlidesItemWrapper?: (item: SliderSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    sliderSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH2Visible?: boolean;
    sliderSectionServicesSlidesH2Renderer?: (item: SliderSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH2Props?: Partial<ComponentProps<"h2">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
};

const HomeSixteenSliderSectionGenerated: FC<HomeSixteenSliderSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    divH20H2Props,
    sliderSectionServicesSlides,
    sliderSectionServicesSlidesItemWrapper,
    sliderSectionServicesSlidesRenderer,
    sliderSectionServicesSlidesH2Visible,
    sliderSectionServicesSlidesH2Renderer,
    sliderSectionServicesSlidesH2Props,
}) => {
    return (
        <section className="slider-section-sixteen one wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide slide-sixteen d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        sliderSectionServicesSlides,
                        (item: SliderSectionServicesSlidesItem) => (
                            <div className={item.divClassName ?? "services-slide"} key={item.key}>
                                {renderItemNode(sliderSectionServicesSlidesH2Visible, sliderSectionServicesSlidesH2Renderer, item, (
                                    <h2 className={item.className} {...(typeof sliderSectionServicesSlidesH2Props === "function" ? sliderSectionServicesSlidesH2Props(item) : (sliderSectionServicesSlidesH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>{item.h20Text}</h2>
                                ))}
                            </div>
                        ),
                        sliderSectionServicesSlidesItemWrapper,
                        sliderSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeSixteenSliderSectionGenerated;
